import { useState } from 'react'
import { ButtonGroup, OverlayTrigger, Tooltip } from 'react-bootstrap'
import {
  CheckCircleFill,
  CloudArrowDown,
  XCircleFill,
} from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { CustomButton } from '../../../components/CustomButton'
import LeroyMerlinService from '../../../services/database/LeroyMerlinService'
import { formatDate } from '../../../utils/formatDate'
import { formatPrice } from '../../../utils/formatPrice'

export function Order({ order, selectedAccountToken, fetchOrders }) {
  const [isImportRequestLoading, setIsImportRequestLoading] = useState(false)
  const ordersStatus = {
    WAITING_DEBIT_PAYMENT: {
      label: 'Aguardando pagamento por débito',
      color: '#ffc300',
    },
    CANCELED: {
      label: 'Cancelado',
      color: '#c70039',
    },
    SHIPPING: {
      label: 'Em envio',
      color: '#27bac1',
    },
    SHIPPED: {
      label: 'Enviado',
      color: '#166aca',
    },
    RECEIVED: {
      label: 'Recebido',
      color: '#27c133',
    },
    DELAYED: {
      label: 'Atrasado',
      color: '#ff5733',
    },
    RETURNED: {
      label: 'Devolvido',
      color: '#ff5733',
    },
    DEFAULT: {
      label: 'Desconhecido',
      color: '#000',
    },
  }

  async function handleImportOrder(orderId) {
    try {
      setIsImportRequestLoading(true)

      await LeroyMerlinService.importOrder(orderId, selectedAccountToken)

      await fetchOrders()

      toast.success('Pedido importado com sucesso!')
    } catch (error) {
      toast.error('Erro ao importar o pedido!')
    } finally {
      setIsImportRequestLoading(false)
    }
  }

  function tranlateStatus(status) {
    if (status === 'WAITING_DEBIT_PAYMENT') {
      return 'Débito em Curso'
    }

    if (status === 'CANCELED') {
      return 'Cancelado'
    }

    if (status === 'RECEIVED') {
      return 'Recebido'
    }

    if (status === 'SHIPPING') {
      return 'Envio em Curso'
    }

    if (status === 'SHIPPED') {
      return 'Enviado'
    }

    return 'FECHADO'
  }

  function getDetailsFromOrderStatus(status) {
    if (status === 'WAITING_DEBIT_PAYMENT') {
      return 'Aguardando pagamento pelo cliente'
    }

    if (status === 'CANCELED') {
      return 'Pedido cancelado'
    }

    if (status === 'RECEIVED') {
      return 'Pedido entregue ao cliente'
    }

    if (status === 'SHIPPING') {
      return 'Pagamento feito, faltando apenas enviar dados da nota e da transportadora'
    }

    if (status === 'SHIPPED') {
      return 'Pedido enviado ao cliente'
    }
  }

  return (
    <tr key={order.order_id}>
      <td>{order.order_id}</td>
      <td>{String(order.customer_name).toUpperCase()}</td>
      <td>{order?.date ? formatDate(order.date) : 'DATA NÃO INFORMADA'}</td>
      <td>{formatPrice(order.price)}</td>
      <OverlayTrigger
        overlay={<Tooltip>{getDetailsFromOrderStatus(order.status)}</Tooltip>}
      >
        <td>
          <span
            style={{
              fontWeight: '500',
              color:
                ordersStatus[order.status]?.color || ordersStatus.DEFAULT.color,
            }}
          >
            {String(tranlateStatus(order.status).toUpperCase())}
          </span>
        </td>
      </OverlayTrigger>
      <td>
        <OverlayTrigger overlay={<Tooltip>Importar</Tooltip>}>
          <CustomButton
            color="#72bf44"
            onClick={() => handleImportOrder(order.order_id)}
            isLoading={isImportRequestLoading}
            isDisabled={
              [
                'CANCELED',
                'CLOSED',
                'WAITING_DEBIT_PAYMENT',
                'RECEIVED',
                'SHIPPED',
              ].includes(order.status) || order.isImported
            }
          >
            <CloudArrowDown />
          </CustomButton>
        </OverlayTrigger>
      </td>
      <td
        style={{
          margin: '0 auto',
        }}
      >
        <ButtonGroup>
          {order.isImported ? (
            <CheckCircleFill
              color="#1e8449"
              size={20}
            />
          ) : (
            <XCircleFill
              color="#c0392b"
              size={20}
            />
          )}
        </ButtonGroup>
      </td>
    </tr>
  )
}
